import { ticksUtils } from '@shared/utils/Trading/TicksUtils';
import { MathUtils } from '@shared/utils/MathUtils';
export function getTradingNumericParameters(variableTickList, price) {
    let tickForParameters = null;
    if (price > variableTickList.at(-1).RightBorder) {
        tickForParameters = variableTickList.at(-1);
    }
    else if (price < variableTickList[0].LeftBorder) {
        tickForParameters = variableTickList[0];
    }
    else {
        tickForParameters = ticksUtils.FindVariableTick(price, variableTickList);
    }
    return {
        step: tickForParameters.PointSize,
        precision: MathUtils.GetDecimalPlaces(tickForParameters.PointSize),
        min: variableTickList[0].LeftBorder,
        max: variableTickList.at(-1).RightBorder
    };
}
